<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="icon ion-settings"></i>
        <div class="mg-l-20">
          <h4>{{$t('product.商品编辑')}}</h4>
        </div>
      </div>
      <div class="tx-right">
       
      </div>
    </div>
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="less" scoped>
.br-pagetitle{
  .icon{
    font-size: 70px;
  }
} 
</style>
